// extracted by mini-css-extract-plugin
export default {"fallback":"_5Dteh2pu","spinner":"_5Dp13z18","spin":"_5DfHQAJz"};